import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatSystemUserDetail,
	formatSystemUserList,
} from './system-user.helper';
import { SystemUserActions } from './system-user.redux';
import {
	IPayloadCreateSystemUserRequest,
	IPayloadDeleteSystemUserRequest,
	IPayloadGetSystemUserDetailRequest,
	IPayloadGetSystemUserListRequest,
} from './system-user.type';

export function* getSystemUserList(
	action: PayloadAction<IPayloadGetSystemUserListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetSystemUserListResponse> =
			yield API.getSystemUserList({ searchTypes, ...rest });

		const content = formatSystemUserList(res?.data?.content);

		yield put(
			SystemUserActions.getSystemUserListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUserActions.getSystemUserListFailure());
	}
}

export function* createSystemUsers(
	action: PayloadAction<IPayloadCreateSystemUserRequest>
) {
	const { callback, ...props } = action.payload;

	try {
		yield API.createSystemUser({
			...props,
		});

		yield put(SystemUserActions.createSystemUserSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUserActions.createSystemUserFailure());
	}
}

export function* deleteSystemUsers(
	action: PayloadAction<IPayloadDeleteSystemUserRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteSystemUser(ids);

		yield put(SystemUserActions.deleteSystemUserSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUserActions.deleteSystemUserFailure());
	}
}

export function* getSystemUserDetail(
	action: PayloadAction<IPayloadGetSystemUserDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.ISystemUser> =
			yield API.getSystemUserDetail(id);

		const systemUserDetail = formatSystemUserDetail(res.data);

		yield put(
			SystemUserActions.getSystemUserDetailSuccess({
				systemUserDetail,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUserActions.getSystemUserDetailFailure());
	}
}
